import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getInitials } from '@/utils/getInitials';
import { cn } from '@/lib/utils';

interface PatientAvatarProps {
    name: string;
    avatarUrl?: string | null;
    className?: string;
    fallbackClassName?: string;
}

export function PatientAvatar({
    name,
    avatarUrl,
    className,
    fallbackClassName,
}: PatientAvatarProps) {
    return (
        <Avatar className={cn('w-12 h-12 ring-1 ring-border/70', className)}>
            {avatarUrl && <AvatarImage src={avatarUrl} alt={name} className="object-cover" />}
            <AvatarFallback className="bg-gradient-to-br from-brand-subtle to-info/10">
                <span className={cn('text-lg font-semibold text-brand', fallbackClassName)}>
                    {getInitials(name)}
                </span>
            </AvatarFallback>
        </Avatar>
    );
}
